import { ItemCapacityBase } from './base/item-capacity-base';

export class ItemCapacity extends ItemCapacityBase { }